import { render, staticRenderFns } from "./SchoolListsBaseFormFooter.vue?vue&type=template&id=03cf301a"
import script from "./SchoolListsBaseFormFooter.vue?vue&type=script&lang=js"
export * from "./SchoolListsBaseFormFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports